import React, {
  useState,
  useContext,
  useCallback,
  SyntheticEvent,
} from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { Button } from "react-bootstrap";
import { FileNameContext } from "../pages/Upload";
import videoSelectedIcon from "../assets/logo/videoselected.png";
import colors from "../utils/colors";

function Dropzone() {
  const [files, setFiles] = useState<any[]>([]);
  const [file, setFile] = useState<File>();
  const [fileName, setFileName] = useState("");
  const [videoStatus, setVideoStatus] = useState("");
  const [fileInfoFromServer, setFileInfoFromServer] = useState<
    { fileName: string; filePath: string } | {}
  >({});
  const { setFileName: setSavedVideoName } = useContext(FileNameContext);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    console.log("files", typeof acceptedFiles, acceptedFiles[0].name);
    setFiles((prevFile) => [
      ...prevFile,
      ...acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      ),
    ]);
    setFile(acceptedFiles[0]);
    setFileName(acceptedFiles[0].name);

    console.log("file----->", acceptedFiles, file, fileName);
    // Do something with the files
  }, []);

  console.log("fileInfoFromServer", fileInfoFromServer);

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({ onDrop });

  const onSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();

    const formData = new FormData();

    if (acceptedFiles) {
      formData.append("file", acceptedFiles[0]);
    } else {
      console.log("file is not chosen");
    }

    try {
      console.log("axios-formdata", formData);
      const res = await axios.post(
        `${process.env.REACT_APP_FILE_UPLOAD}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const videoName = res && res.data.data[0].filename;
      videoName && setSavedVideoName(videoName);
      console.log("res", res, videoName);
      res.status === 200 && setVideoStatus("uploaded");

      setFileInfoFromServer({
        fileName: res.data.fileName,
        filePath: res.data.filePath,
      });
    } catch (err: any) {
      // if (err.reponse.status && err.response.status === 500) {
      if (err) {
        console.log(err);
        console.log("there is a problem with the server");
      } else {
        console.log(err.response.data.msg);
      }
    }
  };

  const check = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-check-lg"
      viewBox="0 0 16 16"
    >
      <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
    </svg>
  );
  return (
    <>
      <form onSubmit={onSubmit}>
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Drop the files here ...</p>
          ) : (
            <p>
              Drop video to upload, or <h4>Browse file</h4>
            </p>
          )}
          {files.map((each) => {
            return (
              <div
                key={each.name}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  marginBottom: "25px",
                  padding: "10px 25px 0px 0px",
                  // border: "1px solid",
                  boxShadow:
                    "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                  // backgroundColor: "yellow",
                }}
              >
                <img src={videoSelectedIcon} alt="preview pic" height="100px" />
                <div>
                  <p>Video Selected</p>
                  <p>{fileName}</p>
                </div>
              </div>
            );
          })}
        </div>
        {fileName && videoStatus !== "uploaded" && (
          <Button
            type="submit"
            variant="primary"
            className="login-btn"
            size="lg"
            style={{ background: colors.SLSsecondary, border: "none" }}
          >
            Upload
          </Button>
        )}

        {videoStatus === "uploaded" && (
          <Button variant="success">Video has been uploaded {check} </Button>
        )}

        {/* <input type="submit" value="Upload" /> */}
      </form>
    </>
  );
}

export default Dropzone;
